import { commitMutation, graphql } from 'react-relay';
import BulkOperationResultDisplay from 'dibs-bulk-operation-result-display'; // eslint-disable-line no-unused-vars

const subjectLine = '1stdibs Shipping Quote Request';

const mutation = graphql`
    mutation drsmRequestShipmentQuoteMutation(
        $input: ShipmentQuoteRequestInput!
        $userId: String!
        $conversationIds: [String]!
        $shouldFetchConversations: Boolean!
    ) {
        shipmentQuoteRequest(input: $input) {
            conversation {
                id
                messages {
                    textBody
                    actionShippingQuoteRequested
                    from {
                        userType
                    }
                    fromUserId
                    fromDisplayName
                    createdDate
                }
                transaction {
                    serviceId
                    isClosed
                    isCanceled
                    isConfirmed
                    isNegotiable
                    isOffPlatformOrder
                    hasCompletedCheckout
                    shipmentQuotes {
                        status
                    }
                    shipment {
                        hasBeenShipped
                        shippingAddress {
                            city
                            state
                            zipCode
                            displayCountry
                        }
                        shipmentTracking {
                            trackingNumber
                            trackingUrl
                            carrier {
                                name
                            }
                        }
                    }
                    summary {
                        checkoutPaymentAuthorization {
                            isPendingApproval
                        }
                        acceptedCommercialQuote {
                            isComplimentary
                            isCustom
                            isLocalPickup
                            handlingTimeDisplay
                            serviceMethod {
                                displayName
                            }
                            totalAmount {
                                amount
                                convertedAmountList {
                                    currency
                                    amount
                                }
                            }
                            author {
                                role
                            }
                        }
                    }
                    lastShipmentQuote(onlyCommercialQuotes: true, onlyCustomQuotes: true) {
                        isFromBuyer
                        isFromDealer
                        isNew
                        is1stdibsQuote
                    }
                }
            }
            ...BulkOperationResultDisplay_bulkOperationResult
            conversations(userId: $userId, conversationIds: $conversationIds)
                @include(if: $shouldFetchConversations) {
                item {
                    serviceId
                }
                originalSeller {
                    displayName
                }
            }
        }
    }
`;

function commit(environment, args) {
    const { conversationIds, userId } = args;

    let input = {
        // Required fields
        buyerId: userId,
        subject: `${subjectLine} for ${args.itemTitle}`,
        // Optional fields
        shippingAddressId: args.shippingAddressId,
        conversationId: args.conversationId,
        country: args.country,
        city: args.city,
        message: args.message || '',
        state: args.state,
        transactionId: args.transactionId,
        zipCode: args.zipCode,
        pageContext: args.pageContext,
        action: 'SHIPPING_REQUEST',
        portfolioIds: args.portfolioIds,
    };

    if (args.itemIds && args.itemIds.length) {
        input = {
            ...input,
            itemIds: args.itemIds,
            subject: subjectLine,
        };
    } else {
        input = {
            ...input,
            itemPk: args.itemId,
            dealerPk: args.dealerPk,
        };
    }

    commitMutation(environment, {
        mutation,
        variables: {
            input,
            userId,
            conversationIds: conversationIds || [],
            shouldFetchConversations: !!(conversationIds && conversationIds.length),
        },
        onCompleted: (payload, errors) => {
            if (errors) {
                args.onFailure(errors);
            } else {
                args.onSuccess(payload);
            }
        },
        onError: error => {
            args.onFailure([error]);
        },
    });
}

export default { commit };
